var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 295,
    viewBox: "0 0 163 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.671 77.7C162.671 35.7 127.571 0.299988 85.5711 0.299988C43.5711 0.299988 8.47109 35.4 8.47109 80.7H24.3711C24.3711 43.5 51.3711 16.5 85.5711 16.5C119.771 16.5 146.771 43.5 146.771 77.7C146.771 84.3 145.571 90.3 144.071 96C135.071 114.6 123.371 131.1 112.871 145.5C102.371 159.9 91.5711 174 81.0711 188.1C69.9711 202.8 58.5711 217.5 47.4711 232.2L0.371094 294.3H157.871V278.1H32.4711L60.3711 242.1C71.4711 227.1 82.5711 212.4 93.6711 197.7C104.471 183.6 114.971 169.5 125.471 155.1C136.271 140.4 148.871 123 157.271 105.3H158.771C158.771 102 158.771 102 156.071 103.8C156.071 103.8 159.071 100.8 159.071 101.1C161.471 93.9 162.671 85.8 162.671 77.7Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber2);
export default __webpack_public_path__ + "static/media/NUMBER_2.ba90254b9da2f18d0c1703b28f75a165.svg";
export { ForwardRef as ReactComponent };